module.exports = __webpack_public_path__ + "img/dsci0126.576bbde6.jpg";